const payrollColumns = {
  END_DATE: 'Period_End_Date',
  PLACEMENT_ID: 'Placement_ID',
  DESCRIPTION: 'Description',
  EARN_CODE: 'Earn_Code',
  TXN_DATE: 'Transaction_Date',
  AMOUNT: 'Amount',
  QTY: 'Qty',
  PAY_RATE: 'Pay_Rate',
  BILLING_RATE: 'Billing_Rate',

  WAE_PLACEMENT_ID: 'WAE_Placement_ID',

  WAE_CANDIDATE_ID: 'WAE_Candidate_ID',
  WAE_CANDIDATE_NAME: 'WAE_Candidate_Name',

  WAE_CORPORATION_ID: 'WAE_Corporation_ID',
  WAE_CORPORATION_NAME: 'WAE_Corporation_Name',

  WAE_TIMECARD_STATUS: 'WAE_Timecard_Status',
  WAE_TIMECARD_IMBALANCED: 'WAE_Timecard_Imbalanced',

  WAE_JOBORDER_ID: 'WAE_Joborder_ID',
  BRANCH: 'Branch',
  PAY_GROUP: 'Pay_Group',
  START: 'Start',
  END: 'End',
  WORKERS_COMP_CODE: 'Workers_Comp_Code',

  WAE_LOCATION_ID: 'WAE_Location_ID',

  BUS_ENTITY: 'Legal_Business_Entity',
  AGENCY: 'Agency_Name',
};

const payroll_v3 = [
  payrollColumns.END_DATE,
  payrollColumns.PLACEMENT_ID,
  payrollColumns.DESCRIPTION,
  payrollColumns.EARN_CODE,
  payrollColumns.TXN_DATE,
  payrollColumns.AMOUNT,
  payrollColumns.QTY,
  payrollColumns.PAY_RATE,
  payrollColumns.BILLING_RATE,

  payrollColumns.WAE_PLACEMENT_ID,

  payrollColumns.WAE_CANDIDATE_ID,
  payrollColumns.WAE_CANDIDATE_NAME,

  payrollColumns.WAE_CORPORATION_ID,
  payrollColumns.WAE_CORPORATION_NAME,

  payrollColumns.WAE_TIMECARD_STATUS,
  payrollColumns.WAE_TIMECARD_IMBALANCED,

  payrollColumns.WAE_JOBORDER_ID,
  payrollColumns.BRANCH,
  payrollColumns.PAY_GROUP,
  payrollColumns.START,
  payrollColumns.END,
  payrollColumns.WORKERS_COMP_CODE,

  payrollColumns.WAE_LOCATION_ID,

  payrollColumns.BUS_ENTITY,
  payrollColumns.AGENCY,
];

const rate_types = { reg: 'REG', over: 'O/T', double: 'DT' };
const invoice_types = { pay: payrollColumns.PAY_RATE, bill: payrollColumns.BILLING_RATE };

module.exports = {
  convertPayrollDataToCSV: (grid, columns) => {
    return [columns]
      .concat(grid)
      .map(row => row.join(','))
      .join('\n');
  },
  invoice_types,
  payrollColumns,
  payroll_v3,
  rate_types,
};
